<h1 class="h3 mb-2 text-gray-800">Continuar con plan de tratamiento</h1>


<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Plan de Tratamiento</h6>
    </div>
    <div class="card-body">
        <form>
            <app-planform [archivos]="archivos" [shouldPrepareInfo]="shouldPrepareInfo" [isAdmin]="isAdmin"
                [editable]="true" [isRefinamiento]="false" [planForm]="plantratamiento"
                (onDataChanged)="onFormChanged($event)"></app-planform>
            <div class="form-group">
                <p><b>Nota.-</b> La revisión de los datos tarda aproximadamente 2 semanas.<br> si hubiera un
                    inconveniente se le notificará lo más pronto posible.</p>
            </div>
            <div class="form-group">
                <ng-container *ngIf="isAdmin && caso.status == estadosCaso.TRATAMIENTO_SOLICITADO">
                    <button type="submit" class="btn btn-success"
                        (click)="openSolicitarAprobacion(aprobacionModal)">Aprobar
                        tratamiento</button>&nbsp;
                    <app-solicitarinformacion caso="caso"></app-solicitarinformacion>
                </ng-container>
                <button type="submit" class="btn btn-primary" (click)="guardarDatos()">Guardar Datos</button>&nbsp;
                <ng-container *ngIf="isSolicitarVisible">
                    <button type="submit" class="btn btn-success" (click)="solicitarTratamiento()">Confirmar y solicitar
                        tratamiento</button>&nbsp;
                </ng-container>
                <a [routerLink]="[ '/casos', this.caso.id,'verpaciente' ]" class="btn btn-link">Volver</a>
            </div>
        </form>
    </div>
</div>
<ng-template #aprobacionModal let-modal>
    <form name="form" (ngSubmit)="f2.form.valid && enviarAprobacion()" #f2="ngForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Aprobación y presupuesto</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">

            <div class="form-group">
                <label for="precioTratamientoBs">Ingrese el monto del presupuesto en Bs:</label>
                <input type="number" class="form-control" name="precioTratamientoBs" id="precioTratamientoBs" required
                    #precioTratamientoBs="ngModel"
                    [ngClass]="{'is-invalid':  f2.submitted && precioTratamientoBs.invalid}"
                    [(ngModel)]="caso.precio_tratamiento_bs" />
                <div *ngIf="f2.submitted && precioTratamientoBs.invalid" class="invalid-feedback">
                    <div *ngIf="precioTratamientoBs.errors.required">El precio es requerido</div>
                </div>
            </div>
            <div class="form-group">
                <label>Enviar PDF de resultados</label>
                <input type="file" #fileuploadTop="ngModel" [(ngModel)]="pdf" name="pdf" accept=".pdf"
                    (change)="seleccionarPdf($event)" class="form-control"
                    [ngClass]="{'is-invalid':  f2.submitted && fileuploadTop.invalid}" required />
                <div *ngIf="f2.submitted && fileuploadTop.invalid" class="invalid-feedback">
                    <div *ngIf="fileuploadTop.errors.required">El PDF es requerido</div>
                </div>
            </div>
            <div class="form-group">
                <label for="videoYoutube">URL del Video en Youtube</label>
                <input class="form-control" name="videoYoutube" #videoYoutube="ngModel"
                    [ngClass]="{'is-invalid':  f2.submitted && videoYoutube.invalid}"
                    [(ngModel)]="caso.video_entrega" />
                <div *ngIf="f2.submitted && videoYoutube.invalid" class="invalid-feedback">
                    <div *ngIf="videoYoutube.errors.required">La URL del video es requerida</div>
                </div>
            </div>
            <!-- <div class="form-group">
                <label for="reunionZoom">Datos de la reunión de zoom</label>
                <textarea class="form-control" name="reunionZoom" #reunionZoom="ngModel"
                    [ngClass]="{'is-invalid':  f2.submitted && reunionZoom.invalid}" style="width: 100%; height: 150px;"
                    [(ngModel)]="caso.reunionZoom"></textarea>
                <div *ngIf="f2.submitted && reunionZoom.invalid" class="invalid-feedback">
                    <div *ngIf="reunionZoom.errors.required">Los datos de la reunión de zoom son requeridos</div>
                </div>
            </div> -->
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark">Enviar aprobación</button>
        </div>
    </form>
</ng-template>